import axios from 'axios';
import routes from '../routing/routes';

export default (): number => axios.interceptors.response.use(
  (response => response),
  (error) => {
    switch (error.response.status) {
      case 401:
        window.location.replace(routes.unauthorized);
        break;
      default:
        break;
    }
    return Promise.reject(error);
  },
);
